import React, { useEffect, useState } from "react";

interface props {
    value: number,
    checkValue: number,
    index: number,
    isValid: (isValid: boolean, index: number) => void
}

const Summary = ( props:props ) => {

    const [isValid, setIsValid] = useState<boolean>(false);
    const [className, setClassName] = useState<string>('summary');

    useEffect(() => {
        if (props.checkValue === 0) {
            setIsValid(false);
            return;
        }

        if (props.checkValue !== props.value) {
            setIsValid(false);
            return;
        }

        setIsValid(true);

    }, [props.value, props.checkValue]);

    useEffect(() => {
        props.isValid(isValid, props.index);

        if (isValid) {
            setClassName('summary valid');
            return;
        }

        if (props.checkValue > 0) {
            setClassName('summary invalid');
            return;
        }

        setClassName('summary');

    }, [isValid, props.checkValue]);


    return (<div className={className}>{props.value}</div>);
};

export { Summary };
